module.exports = __webpack_public_path__ + "img/x.4ee9e6de.jpg";